// Where a tapped office alert lands in the admin app.
//
// The service worker opens the portal at the alert's URL when the app was closed. When it
// was ALREADY open it sends a message instead — navigating a running app would reload it,
// and `client.navigate()` is unreliable on iOS. This listens for that message and routes.
//
// The driver portal does its own version of this (switching tabs rather than routes), so
// this only handles paths the admin app owns. Deliberately an allowlist: a URL arriving
// from outside the React tree should never be handed straight to the router.
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ALLOWED = new Set(['/customer-cases']);

export default function PushDeepLink() {
  const navigate = useNavigate();
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    const onMsg = (e) => {
      if (!e.data || e.data.type !== 'hp-open') return;
      try {
        const u = new URL(e.data.url, window.location.origin);
        if (ALLOWED.has(u.pathname)) navigate(u.pathname + u.search);
      } catch (err) { /* not a URL we can route to */ }
    };
    navigator.serviceWorker.addEventListener('message', onMsg);
    return () => navigator.serviceWorker.removeEventListener('message', onMsg);
  }, [navigate]);
  return null;
}
